import styled from 'styled-components';

import StyledText from '../../components/shared/StyledText';
import { withI18next } from '../../lib/withI18next';
import { WHITE_COLOR, TABLET_SIZE } from '../../constants';
import { string, bool } from 'prop-types';

const StyledHeader = styled(StyledText)`
  @media (max-width: ${TABLET_SIZE}) {
    display: none;
  }
`;

const Container = styled.div`
  background-size: cover;
  background-image: ${({ bgImage }) => bgImage};
  margin-top: ${({ marginTop }) => marginTop};
  background-position: center center;
  height: ${({ imgHeight }) => imgHeight};
  padding: 100px 60px 0px 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  font-size: 4vw;
  @media (max-width: ${TABLET_SIZE}) {
    height: 125px;
    font-size: 30px;
    padding: 100px 40px 0px 15px;
  }
`;

const IntroImageWithText = ({
  t,
  bgImage,
  inventiClaim,
  height,
  marginTop,
}) => (
  <Container imgHeight={height} bgImage={bgImage} marginTop={marginTop}>
    <StyledHeader isBold color={WHITE_COLOR}>
      {inventiClaim
        ? "It's about the people"
        : t('COMPONENTS_SHARED_MAIN_TITLE')}
    </StyledHeader>
  </Container>
);

IntroImageWithText.propTypes = {
  bgImage: string.isRequired,
  inventiClaim: bool,
  height: string.isRequired,
  marginTop: string,
};

export default withI18next()(IntroImageWithText);



// WEBPACK FOOTER //
// components/shared/IntroImageWithText.js